import { EntityDetailSkeleton, Card, CardContent } from '@yeshuman/sdk'
import { useOpportunity } from '../../hooks/use-organisation-opportunities'
import { useParams } from 'react-router-dom'

import { EmployerTalentPanel } from './employer-talent-panel'

export function JobWorkspaceTalentTab() {
  const { jobId = '' } = useParams<{ jobId: string }>()
  const { data: opportunity, isLoading } = useOpportunity(jobId)

  if (isLoading) {
    return <EntityDetailSkeleton variant="job" ariaLabel="Loading talent" />
  }

  if (opportunity?.publication_status === 'draft') {
    return (
      <Card>
        <CardContent className="py-8 text-sm text-muted-foreground">
          Publish this job before viewing talent rankings.
        </CardContent>
      </Card>
    )
  }

  if (!opportunity) {
    return <EntityDetailSkeleton variant="job" ariaLabel="Loading talent" />
  }

  return (
    <EmployerTalentPanel opportunityId={jobId} opportunityTitle={opportunity.title} />
  )
}

/** @deprecated Use JobWorkspaceTalentTab */
export const JobWorkspaceAnalysisTab = JobWorkspaceTalentTab
